import { CommonConstant } from "shared/constants/common-constant"
import { formatStandardDate, parseDate } from "utils/date-helper"
import { useStores } from "stores/root-store"
import { WarningMessage, WarningMessageWrapper } from "components/common/styles"
import { Box, CardContent, CardHeader, Card } from "@mui/material"
import NoRecordImage from "assets/estore-NoRecord.png"
import { CustomDataGrid } from "components/common-styles"
import { useEffect, useState } from "react"
import { format } from "date-fns"
import { GridToolbarContainer } from "@mui/x-data-grid"
import CustomExportButton from "components/common/custom-export-button"

function CustomToolbarInventory(props) {
  return (
    <GridToolbarContainer>
      <CustomExportButton exportOptions={props.exportOptions} />
    </GridToolbarContainer>
  )
}

const ProductHistory = () => {
  const { InventoryStore } = useStores()
  const productMovement = [...InventoryStore.productMovement]
  const [exportFileName, setExportFileName] = useState("")

  const columns = [
    {
      field: "warehouse",
      headerName: "Warehouse",
    },
    {
      field: "product",
      headerName: "Product",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "product_description",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "transaction",
      headerName: "Transaction",
    },
    {
      field: "direction",
      headerName: "Direction",
    },
    {
      field: "reference",
      headerName: "Reference",
    },
    {
      field: "quantity",
      headerName: "Qty",
      type: "number",
    },
    {
      field: "activity_datetime",
      headerName: "Activity Date Time",
      width: 140,
      renderCell: params => {
        return formatStandardDate(params.value)
      },
    },
  ]

  useEffect(() => {
    const pathNames = location.hash.split("/").filter(x => x && x != "#")
    const productId = decodeURIComponent(pathNames.length > 1 ? pathNames[1] : "")
    setExportFileName(`Express_Inventory_ProductHistory.${productId}-${format(new Date(), "ddMMyyyy.HHmm")}`)
  }, [])

  return (
    <Card>
      <CardHeader title="Product History" />
      <CardContent>
        {!productMovement || productMovement.length == 0 ? (
          <WarningMessageWrapper>
            <Box component="img" sx={{ maxWidth: 200 }} src={NoRecordImage} />
            <WarningMessage>{"The requested product could not be located in the system. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."}</WarningMessage>
          </WarningMessageWrapper>
        ) : (
          <CustomDataGrid
            getRowId={row => `${row.key}`}
            rows={productMovement}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [{ field: "warehouse", sort: CommonConstant.ASCENDING }],
              },
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
            pageSizeOptions={[10, 15, 20, 50]}
            slots={{
              toolbar: CustomToolbarInventory,
            }}
            slotProps={{
              toolbar: {
                exportOptions: { hiddenColumns: {}, columns: columns, fileName: exportFileName, data: productMovement },
              },
            }}
          />
        )}
      </CardContent>
    </Card>
  )
}

export default ProductHistory
